import { ArrayInput, SimpleFormIterator, TextInput } from "react-admin";
import { Grid } from "@mui/material";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import permissions from "app/permissions";
import { settings } from "app";

const SaveForm = ({ edit: isEdit }) => {
  const hasManagePermission = checkPermission(getPermissions(), permissions.canManageEmailGroups);

  return (
    <>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          md={3}
          xs={12}
        >
          <TextInput
            label="Име на група"
            source="name"
            disabled={isEdit ? !hasManagePermission : false}          
          />
        </Grid>
        <Grid
          item
          md={12}
          xs={12}
        >
          <TextInput
            type="textarea"
            label="Описание"
            source="description"
            disabled={!hasManagePermission}
            multiline
          />
        </Grid>
      </Grid>
      
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            md={5}
            xs={12}
          >
            <ArrayInput
              source="emails"
              label="Получатели"
            >
              <SimpleFormIterator
                disableReordering
                disabled={!hasManagePermission}
                sx={settings.style.iteratorWithoutGap}
              >
                <TextInput
                  label="Имейл адрес"
                  disabled={!hasManagePermission}
                />
              </SimpleFormIterator>
            </ArrayInput>
          </Grid>
        </Grid>
    </>
  );
};

export default SaveForm;
